(function () {
  'use strict';

  var choiceKey = 'ougist-language-choice';
  var redirectKey = 'ougist-language-redirected';

  function read(storage, key) {
    try { return storage.getItem(key); } catch (error) { return null; }
  }

  function write(storage, key, value) {
    try { storage.setItem(key, value); } catch (error) { /* storage is optional */ }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-language-code]');
    if (button && event.isTrusted) write(window.localStorage, choiceKey, button.getAttribute('data-language-code'));
  });

  var path = window.location.pathname || '/';
  if (/^\/es(?:\/|$)/i.test(path)) return;
  if (/^\/(?:admin|checkout|checkouts|localization|challenge|apps)(?:\/|$)/i.test(path)) return;
  if (/(?:bot|crawler|spider|crawling|google|bing|yandex|baidu)/i.test(navigator.userAgent || '')) return;

  var saved = read(window.localStorage, choiceKey);
  var target;
  if (saved === 'es' || saved === 'auto-es') {
    target = 'es';
  } else if (saved === 'en' || saved === 'auto-en') {
    target = 'en';
  } else {
    var preferred = (navigator.languages && navigator.languages[0]) || navigator.language || '';
    target = /^es(?:-|$)/i.test(preferred) ? 'es' : 'en';
    write(window.localStorage, choiceKey, 'auto-' + target);
  }

  if (target !== 'es' || read(window.sessionStorage, redirectKey) === '1') return;

  var languageButton = document.querySelector('[data-language-code="es"]:not([disabled])');
  if (!languageButton || !languageButton.form) return;

  var returnTo = languageButton.form.querySelector('[name="return_to"]');
  if (returnTo) returnTo.value = path + window.location.search + window.location.hash;

  var localeCode = document.createElement('input');
  localeCode.type = 'hidden';
  localeCode.name = 'locale_code';
  localeCode.value = 'es';
  languageButton.form.appendChild(localeCode);

  write(window.sessionStorage, redirectKey, '1');
  function submitLanguage() { languageButton.form.submit(); }
  if (document.readyState === 'complete') {
    submitLanguage();
  } else {
    window.addEventListener('load', submitLanguage, { once: true });
  }
}());
